import { createTheme, MantineThemeComponent } from "@mantine/core";

const fontFamily =
  "'Plus Jakarta Sans Variable', 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

const heroFontFamily =
  "'Source Serif 4 Variable', 'Source Serif 4', Georgia, serif";

export { heroFontFamily };

/* Every toast wears the elevated card look the app-update notification
   introduced: soft rounding plus a hairline border, without which a white
   toast has no edge against the app's white background. `withBorder` (rather
   than a hand-rolled border) keeps Mantine's light/dark border colors.

   Only defaults, so any single `notifications.show()` can still opt out. The
   matching deeper shadow lives in index.css — Notification takes no `shadow`
   prop. Applied via App.tsx's provider, whose `components` map replaces the
   one below; lives here so it sits with the rest of the app's styling (and so
   tests can assert on it without loading the app). */
export const notificationTheme: MantineThemeComponent = {
  defaultProps: {
    radius: "lg",
    withBorder: true,
  },
};

export const theme = createTheme({
  // Mantine's default breakpoints work well for most apps:
  // xs: 576px, sm: 768px, md: 992px, lg: 1200px, xl: 1400px

  primaryColor: "orange",
  cursorType: "pointer",

  fontFamily,

  headings: {
    fontFamily,
    fontWeight: "700",
    sizes: {
      h1: {
        // Fluid: ~1.75rem at 320px viewport up to 2.5rem at ≥768px
        fontSize: "clamp(1.75rem, 1.2rem + 2.7vw, 2.5rem)",
        lineHeight: "1.2",
        fontWeight: "700",
      },
      h2: {
        // Fluid: ~1.5rem at 320px viewport up to 2rem at ≥768px
        fontSize: "clamp(1.5rem, 1.15rem + 1.8vw, 2rem)",
        lineHeight: "1.25",
        fontWeight: "700",
      },
      h3: {
        fontSize: "1.5rem",
        lineHeight: "1.3",
        fontWeight: "600",
      },
      h4: {
        fontSize: "1.25rem",
        lineHeight: "1.4",
        fontWeight: "600",
      },
      h5: {
        fontSize: "1.125rem",
        lineHeight: "1.5",
        fontWeight: "600",
      },
      h6: {
        fontSize: "1rem",
        lineHeight: "1.5",
        fontWeight: "600",
      },
    },
  },

  // Mobile-first font sizes
  fontSizes: {
    xs: "0.75rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
  },

  // Responsive spacing
  spacing: {
    xs: "0.5rem",
    sm: "0.75rem",
    md: "1rem",
    lg: "1.5rem",
    xl: "2rem",
  },

  // Use Mantine's built-in responsive props instead of custom CSS
  components: {
    Button: {
      styles: {
        root: {
          // Basic button improvements without media queries
          minHeight: "40px",
          fontWeight: 500,
          letterSpacing: "0.01em",
        },
      },
    },
  },
});
